import React, { useRef } from 'react';
var VeltActivityLogListShowMore = function (props) {
    var defaultCondition = props.defaultCondition, dateGroup = props.dateGroup, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-list-show-more", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "date-group": dateGroup }, children));
};
export default VeltActivityLogListShowMore;
